import { render, staticRenderFns } from "./BeneficiaryDetail.vue?vue&type=template&id=12ce04b0&scoped=true"
import script from "./BeneficiaryDetail.vue?vue&type=script&lang=js"
export * from "./BeneficiaryDetail.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaryDetail.vue?vue&type=style&index=0&id=12ce04b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ce04b0",
  null
  
)

export default component.exports